export type IGeoLocation = ReturnType<typeof geoLocationFactory>;

/* @ngInject */
export function geoLocationFactory($q, $window, $timeout) {
  return {
    getLocation,
  };

  function getLocation() {
    const deferred = $q.defer();
    let timer;
    const success = function(position) {
      $timeout.cancel(timer);
      deferred.resolve(position);
    };
    const failure = function() {
      $timeout.cancel(timer);
      reject();
    };

    const reject = function() {
      deferred.reject();
    };
    const options = { timeout: 30000 };
    if ($window.navigator && $window.navigator.geolocation) {
      timer = $timeout(function() {
        reject();
      }, 15000);
      $window.navigator.geolocation.getCurrentPosition(
        success,
        failure,
        options,
      );
    } else {
      deferred.reject('Unsupported browser');
    }
    return deferred.promise;
  }
}
